import {Button, Form, FormControl, InputGroup, Table,  Pagination, Col, Row} from "react-bootstrap";
import React, {useEffect, useMemo, useState} from "react";
import {useAuth} from "../../providers/authprovider";
import AddBuildingForm from "./AddBuildingForm";
import Building from "./Building";
import {Route, Routes,  useSearchParams, useParams} from "react-router-dom";
import {
    Link, useNavigate
} from "react-router-dom";
import {ControlledMenu, MenuItem, useMenuState} from "@szhsin/react-menu";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faClockRotateLeft, faCalendarDay, faCaretDown, faCaretUp, faEdit} from "@fortawesome/free-solid-svg-icons";
import ResponseAlert from "../../components/ResponseAlert";
import Notes from "./Notes";
import {useRemember} from "../../providers/rememberprovider";
import MultiSelect from "../../components/MultiSelect";
import BuildingImageGallery from "./BuildingImageGallery";




export default function Buildings(props){
    const {privilege} = props;
    const {buildings : {get, deleteBuilding}, teams:{get : loadTeams},} = useAuth();
    const navigate = useNavigate();
    const [buildings, setBuildings] = useState(undefined);
    const [teams, setTeams] = useState(undefined);
    const [editedBuilding, setEditedBuilding] = useState(undefined);
    const [alert, setAlert] = useState({show:false, error: ""})

    useEffect(()=>{
        if(teams === undefined){
            loadTeams(({success, error, content})=>{
                if(success)
                    return setTeams(content);

                setTeams([]);
                setAlert({show:true, error: error})
            })
            return;
        }

        if(buildings !== undefined)
            return;

        get(({success,error, content})=>{

            if(success)
                return setBuildings(content.map(b=>new Building(b)));

            setBuildings([]);
            setAlert({show:true, error: error})
        })
    })

    const handleBuildingSaved = (building)=>{

        const existingIndex = buildings.findIndex(c=>c.id === building.id)
        if(existingIndex > -1)
            buildings.splice(existingIndex, 1, new Building(building))
        else
            buildings.push(new Building(building))

        setBuildings([...buildings]);
    }

    const handleditBuilding = (building)=>{
        setEditedBuilding(building.props);
        navigate("/buildings/create");
    }

    const deleteBuildingHandle = (buildingId, reason)=>{
        deleteBuilding(buildingId, reason, ({success, error, content})=>{
            if(!success)
                return window.alert(error)

            setBuildings(buildings.filter(b=>b.id !== buildingId))
            window.alert("Obiekt został usunięty.")
        })
    }

    if(!buildings)
        return ("");

    return (
        <div>
            <Routes>
                <Route path="/" element={
                    <>
                        <ResponseAlert show={alert.show} error={alert.error} />
                        {
                            privilege.edit &&
                            <Link to={"./create"}
                                  className="btn btn-primary mt-3 me-4 float-end"

                                  onClick={()=>{setEditedBuilding(undefined);}} >Dodaj</Link>

                        }

                        <BuildingList
                            privilege={privilege}
                            teams={teams}
                            onEdit={handleditBuilding}
                            buildings={buildings}
                            onDelete = {deleteBuildingHandle}
                        />
                    </>
                } />
                 <Route path=":buildingId" element={
                    <BuildingList
                        privilege={privilege}
                        teams={teams}
                        onEdit={handleditBuilding}
                        buildings={buildings}
                        onDelete={deleteBuildingHandle}
                    />
                } />
                <Route path="/create" element={
                    <AddBuildingForm building={editedBuilding} teams={teams} privilege={privilege} onBuildingSaved={handleBuildingSaved} />
                }
                
                />
                
                
                <Route path="/images/:buildingId/*" element={
                    <BuildingImageGallery />
                }
                />
            </Routes>
        </div>
    )
}

function prepareStateList(buildings){

    const list = [];

    buildings?.forEach(b=>{
        if(b.props.status === undefined || b.props.status === null || b.props.status.trim().length <= 0)
            return;

        if(!list.includes(b.props.status))
            list.push(b.props.status);
    })

    return list.map(l=> {
        return {value: l, name: l}
    });
}


function BuildingList(props){
    let {buildingId} = useParams();
    const {privilege, teams}  = props;
    const {user} = useAuth();
    const columns = [
        {key:"name", title:"Obiekt"},
        {key:"address", title:"Adres"},
        {key:"next_inspection_date", title:"Kolejny przegląd"},
        {key:"inspections_grid", title:"Przeglądy"},
        {key:"description", title: "Opis"},
        {key:"supervisor_team", title:"Ekipa prowadząca"},
        {key:"folder_num", title: "Nr umowy"},
        {key:"project_num", title: "Nr projektowy"},
    ]

    const navigate = useNavigate();
    const stateList = prepareStateList(props.buildings);
    const {setValue, getValue} = useRemember();
    const [searchParams] = useSearchParams();
    const searchClientId = searchParams.get('clientId');
    const [menuProps, toggleMenu] = useMenuState();
    const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
    const [contextMenuBuilding, setContextMenuBuilding] = useState(undefined);
    const [searchTimingHook, setSearchTimingHook] = useState(undefined);
    const [searchQuery, setSearchQuery] = useState(getValue("searchQuery", ""));
    const [filters, setFilters] = useState([]);
    const [showNotes, setShowNotes] = useState(false);
    const [currentPage, setCurrentPage] = useState(getValue("currentPage", 0));
    const [sortBy, setSortBy] = useState(getValue("sortBy", {key:null, order:'asc'}));


    useEffect(()=>{
        setValue("sortBy", sortBy)
        setValue("currentPage", currentPage)
        setValue("searchQuery", searchQuery)
    });

    const setSorting = (key)=>{
        setSortBy(prevState => {
            if(prevState.key !== key)
                return {key:key, order:'asc'}

            if(prevState.order === 'asc')
                return {key:key, order:'desc'}

            return {key:key, order:'asc'}
        })
    }

    const buildings = useMemo(()=>{
        const result = props.buildings
            .filter(
                (building)=>building.id === buildingId || buildingId === undefined
            )
            .filter((building)=>{
                if(searchClientId === null)
                    return true;

                return building.props.client_id === searchClientId;
            })
            .filter((building)=>building.checkForSearchQuery(searchQuery))
            .filter(building=>{
                if(filters.length === 0) return true;
                return filters.includes(building.props.status);
            });

        return result.sort((buildingA, buildingB)=> buildingA.compareTo(buildingB, sortBy.key, sortBy.order))
    }, [searchQuery, props.buildings, sortBy, filters, searchClientId]);

    const pages = useMemo(()=>{
        let items = [];
        if(buildings === undefined || buildings.length<=0)
            return items;

        items.push(<Pagination.Prev key={-1} onClick={()=>setCurrentPage(Math.max(currentPage-1, 0))} />)

        const pagesNum = Math.ceil(buildings.length / 50);


        for(let i=0; i< pagesNum; i++){

            items.push(
                <Pagination.Item key={i} active={i === currentPage} onClick={()=>setCurrentPage(i)}>
                    {i+1}
                </Pagination.Item>
            );
        }

        // <Pagination.Ellipsis />

        items.push(<Pagination.Next  key={pagesNum+1} onClick={()=>setCurrentPage(Math.min(currentPage+1, pagesNum-1))} />)

        return items;
    }, [currentPage, buildings]);

    const handleSearch = (e)=>{

        e.preventDefault();
        e.stopPropagation();

        const form = e.currentTarget;

        performSearch(form.elements['searchField'].value);
    }

    const handleTypingSearch = e=>performSearch(e.target.value);

    function performSearch(query){
        clearTimeout(searchTimingHook);

        const hook = setTimeout(
            function(){
                setCurrentPage(0)
                setSearchQuery(query);
            }, 400
        )

        setSearchTimingHook(hook)
    }

    const handleEditBuilding = ()=>{
        if(props.onEdit && contextMenuBuilding !== undefined)
            props.onEdit(contextMenuBuilding);
    }

    const handleShowNotes = (building)=>{
        setContextMenuBuilding(building);
        setShowNotes(true);
    }

    const handleOpenBuildingEdition = (buildingId)=>{
        const building = props.buildings.find(b=>b.id === buildingId);
        if(!building)
            return;

        props.onEdit(building);
    }

    if(!teams)
        return ("");

    const handleDeleteBuilding = ()=>{
        if(!contextMenuBuilding) return;

        const reason = window.prompt("Proszę wprowadzić powód usunięcia obiektu: "+contextMenuBuilding.get("name"));

        if(reason.length <= 0)
            return alert("Proszę podać powód usunięcią obiektu.")

        props.onDelete(contextMenuBuilding.id, reason)
    }

    const menuItemDelete = user.isAdmin ? <MenuItem onClick={handleDeleteBuilding}>Usuń</MenuItem> : ""

    return (
        <div className={"p-2 table_containers"} >
            {
                privilege.edit ?
                <ControlledMenu {...menuProps} anchorPoint={anchorPoint}
                                onClose={() => toggleMenu(false)}>
                    <MenuItem onClick={handleEditBuilding}>Edytuj</MenuItem>
                    <MenuItem onClick={()=> {
                        setShowNotes(true)
                    }}>Historia obiektu </MenuItem>
                    {menuItemDelete}
                </ControlledMenu>
                    :
                <ControlledMenu {...menuProps} anchorPoint={anchorPoint}
                                    onClose={() => toggleMenu(false)}>
                        <MenuItem onClick={handleEditBuilding}>Podgląd</MenuItem>
                    {menuItemDelete}
                </ControlledMenu>
            }
            <Row className={"w-50"}>
                <Col>
                    <Form onSubmit={handleSearch} >
                        <InputGroup className="mb-3 ">
                            <FormControl
                                placeholder="wpisz szukaną frazę"
                                aria-label="search placeholder"
                                aria-describedby="seach_field"
                                name={"searchField"}
                                onChange={handleTypingSearch}
                                defaultValue={searchQuery}
                            />
                            <Button type={"submit"} variant="outline-secondary" id="button-addon2">
                                Szukaj
                            </Button>
                        </InputGroup>
                    </Form>
                </Col>
                <Col>
                    <MultiSelect elements={stateList} title={"Status"} onChange={(v)=>{setFilters(v)}} />
                </Col>
            </Row>



            <Table size={"sm"} striped bordered hover  >
                <thead>
                <tr  >
                    <th>#</th>
                    <th ><FontAwesomeIcon icon={faClockRotateLeft} title={"Historia obiektu"} /></th>
                    {
                        columns.map(col=>
                                <th width={col.width} onClick={()=>setSorting(col.key)} className={"cursor-pointer"} key={col.key}>
                                    <div className={"text-nowrap"}>
                                        {col.title}
                                        {
                                            col.key === sortBy.key ? <>&nbsp;<FontAwesomeIcon icon={sortBy.order === 'desc' ? faCaretDown : faCaretUp} /></>: null
                                        }
                                    </div>
                                </th>
                        )
                    }
                </tr>
                </thead>
                <tbody>
                {
                    buildings && buildings.map((building,lp)=>{
                        const startPos = currentPage*50;
                        const endPos = startPos+50;

                        if(lp < startPos || lp >= endPos)
                            return;

                        const props = {
                            editionAllowed : privilege.edit,
                            teams : teams
                        }

                        const historyFont =<FontAwesomeIcon icon={faCalendarDay} title={"Obiekt posiada historię"} style={{cursor:"pointer"}} onClick={()=>handleShowNotes(building)} /> ;


                        return (
                            <tr id={building.id} key={building.id} onContextMenu={e => {
                                e.preventDefault();
                                setAnchorPoint({ x: e.clientX, y: e.clientY });
                                toggleMenu(true);
                                setContextMenuBuilding(building)
                            }}>
                                <td>{lp+1} </td>
                                <td>{historyFont}</td>
                                {
                                    columns.map(col=>{
                                        let val = building.get(col.key, props)
                                        return <td key={col.key+"_"+building.id}><div className={`tdDiv ${col.key} `}>{val}</div></td>
                                    })
                                }
                                <td><Button variant={"outline-secondary"} onClick={()=>handleOpenBuildingEdition(building.id)} ><FontAwesomeIcon icon={faEdit} /></Button> </td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </Table>

            <Pagination style={{justifyContent: 'center'}}>
                { pages }
            </Pagination>
            {
                showNotes &&
                <Notes privilege={privilege} building={{id:contextMenuBuilding.id, name:contextMenuBuilding?.props.name}} onHide={()=>setShowNotes(false)} />
            }

        </div>
    )
}

